import { MutableRefObject, useContext, useEffect, useRef } from 'react'
import { UserContext, UserContextState, UserContextType } from '../UserContext'

export default function useUserContextRef() {
    const { state: userState } = useContext(UserContext) as UserContextType

    const userStateRef = useRef<UserContextState>(userState)

    useEffect(() => {
        userStateRef.current = userState
    }, [userState])

    return {
        userStateRef: userStateRef as MutableRefObject<UserContextState>,
    }
}
